"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const ExpandCardButton_1 = __importDefault(require("../../atoms/ExpandCardButton"));
const infobox_1 = require("@completeanatomy/infobox");
const LabelCards_1 = __importDefault(require("../LabelCards"));
const ui_1 = require("@completeanatomy/ui");
const html_1 = require("../../utils/html");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const model_systems_1 = require("@completeanatomy/model-systems");
const hooks_1 = require("../../hooks");
const providers_1 = require("../../providers");
const BOTTOM_OFFSET = 200;
// eslint-disable-next-line max-lines-per-function
function DefaultLabelCard({ identifier, title, subtitle, description, defaultPosition, locked, selectedToolType, onExpanded, setUpdatePosition, }) {
    var _a, _b;
    const { selectedLabelID } = (0, hooks_1.useLabels)();
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(false);
    const [expandedHeight, setExpandedHeight] = (0, react_1.useState)(0);
    const [expandedOffset, setExpandedOffset] = (0, react_1.useState)(0);
    const descriptionRef = (0, react_1.useRef)(null);
    const windowSize = (0, ui_1.useScreenSize)();
    const cardRef = (0, react_1.useRef)(null);
    const originalPosRef = (0, react_1.useRef)(defaultPosition);
    const toolsService = (0, providers_1.useToolsService)();
    const labelManager = toolsService === null || toolsService === void 0 ? void 0 : toolsService.getLabelToolManager();
    const { isMobile } = (0, device_1.usePlatform)();
    const [isCollapsing, setIsCollapsing] = (0, react_1.useState)(false);
    const isSelected = identifier === selectedLabelID;
    const isExpandable = description.length > 0 && isSelected && selectedToolType === bridge_schema_1.ToolType.None;
    const system = (0, model_systems_1.useSystemState)();
    const showSubTitle = ((_a = system[0]) === null || _a === void 0 ? void 0 : _a.activeLayerIndex) === 4 && (subtitle === null || subtitle === void 0 ? void 0 : subtitle.trim()) !== '';
    const onExpand = (0, react_1.useCallback)(() => {
        if (isExpanded) {
            setIsCollapsing(true);
        }
        let topOffset = 0;
        if (!isExpanded && descriptionRef.current) {
            const rect = descriptionRef.current.getBoundingClientRect();
            if (rect.top + expandedHeight > document.body.clientHeight) {
                topOffset =
                    document.body.clientHeight - (expandedHeight + BOTTOM_OFFSET);
                setExpandedOffset(topOffset);
            }
            setUpdatePosition(false);
        }
        else {
            setExpandedOffset(0);
            labelManager === null || labelManager === void 0 ? void 0 : labelManager.updateLabelPosition(identifier, {
                x: originalPosRef.current.x,
                y: originalPosRef.current.y,
            });
        }
        setIsExpanded(!isExpanded);
        onExpanded(!isExpanded ? identifier : null);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isExpanded, setIsExpanded, expandedHeight, identifier, onExpanded]);
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (event) => {
            if (cardRef.current && !cardRef.current.contains(event.target)) {
                setIsExpanded(false);
                setExpandedOffset(0);
                onExpanded(null);
            }
        };
        if (locked) {
            setIsExpanded(false);
            setExpandedOffset(0);
            onExpanded(null);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [locked, onExpanded]);
    const calculateExpandedHeight = (element) => {
        (0, html_1.calculateHeight)(element).then(height => {
            if (height >= 0) {
                setExpandedHeight(Math.min(height, document.body.offsetHeight * 0.7));
            }
        });
    };
    (0, react_1.useEffect)(() => {
        if (descriptionRef.current && document.body.clientHeight > 0) {
            calculateExpandedHeight(descriptionRef.current);
        }
    }, [windowSize.height]);
    (0, react_1.useEffect)(() => {
        if (!originalPosRef.current) {
            originalPosRef.current = defaultPosition;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useEffect)(() => {
        if (!isCollapsing)
            return;
        let frameId;
        const update = () => {
            labelManager === null || labelManager === void 0 ? void 0 : labelManager.updateLabelPosition(identifier, {
                x: originalPosRef.current.x,
                y: originalPosRef.current.y,
            });
            setUpdatePosition(prev => !prev);
            frameId = requestAnimationFrame(update);
        };
        frameId = requestAnimationFrame(update);
        return () => cancelAnimationFrame(frameId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCollapsing]);
    return ((0, jsx_runtime_1.jsx)(StyledLabelCard, { identifier: identifier, type: bridge_schema_1.LabelType.Default, defaultPosition: defaultPosition, "$expandedOffset": expandedOffset, locked: locked, selectedToolTypeProp: selectedToolType, isExpanded: isExpanded, originalPosRef: originalPosRef, "data-e2e": 'DefaultLabelCard_StyledLabelCard', children: (0, jsx_runtime_1.jsxs)(Content, { ref: cardRef, "data-e2e": 'DefaultLabelCard_Content', children: [(0, jsx_runtime_1.jsx)(Title, { selected: isSelected, "data-e2e": 'DefaultLabelCard_Title', children: title }), !isMobile && (((_b = system[0]) === null || _b === void 0 ? void 0 : _b.activeLayerIndex) !== 4 || showSubTitle) && ((0, jsx_runtime_1.jsxs)(SubTitle, { selected: isSelected, "data-e2e": 'DefaultLabelCard_SubTitle', children: ["(", subtitle, ")"] })), isMobile && isExpandable && ((0, jsx_runtime_1.jsx)(InfoButton, { onClick: onExpand, "data-e2e": 'DefaultLabelCard_InfoButton', children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Info, selected: isExpanded, "data-e2e": 'DefaultLabelCard_Icon' }) })), description.length > 0 && ((0, jsx_runtime_1.jsx)(DescriptionContent, { ref: descriptionRef, expanded: isExpanded, expandedHeight: expandedHeight, onTransitionEnd: () => {
                        // When collapse finishes
                        if (!isExpanded) {
                            labelManager === null || labelManager === void 0 ? void 0 : labelManager.updateLabelPosition(identifier, {
                                x: originalPosRef.current.x,
                                y: originalPosRef.current.y,
                            });
                            setUpdatePosition(true);
                            setIsCollapsing(false);
                        }
                    }, "data-e2e": 'DefaultLabelCard_DescriptionContent', children: (0, jsx_runtime_1.jsx)(StyledDescription, { "data-e2e": 'DefaultLabelCard_StyledDescription', children: description }) })), !isMobile && ((0, jsx_runtime_1.jsx)(ExpandCardButton_1.default, { expandable: isExpandable, expanded: isExpanded, ellipsis: true, onClick: onExpand, "data-e2e": 'DefaultLabelCard_ExpandCardButton' }))] }) }));
}
exports.default = (0, react_1.memo)(DefaultLabelCard);
const StyledLabelCard = (0, styled_components_1.default)(LabelCards_1.default) `
  ${({ $expandedOffset, isExpanded }) => isExpanded &&
    $expandedOffset !== 0 &&
    (0, styled_components_1.css) `
      top: ${$expandedOffset}px;

      z-index: 1;
    `};
`;
const Content = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-direction: column;
  flex-grow: 1;

  box-sizing: border-box;

  padding: 10px;
`;
const Title = styled_components_1.default.div `
  color: ${({ theme, selected }) => selected ? theme.text : theme.textSecondary};

  font-weight: ${({ selected }) => (selected ? '800' : '400')};
  font-size: 16px;
  user-select: auto;
`;
const SubTitle = styled_components_1.default.div `
  color: ${({ theme, selected }) => selected ? theme.text : theme.textSecondary};

  font-weight: ${({ selected }) => (selected ? '800' : '400')};
  font-size: 14px;
  font-style: italic;
  user-select: auto;
`;
const DescriptionContent = styled_components_1.default.div `
  height: ${({ expanded, expandedHeight }) => expanded ? `${expandedHeight}px` : '0'};

  overflow: hidden;
  transition: height 0.3s;
`;
const StyledDescription = (0, styled_components_1.default)(infobox_1.InfoBoxDescription) `
  flex-shrink: unset;

  box-sizing: border-box;

  padding: 10px 0;

  color: ${({ theme }) => theme.text};

  font-size: 16px;
`;
const InfoButton = styled_components_1.default.button `
  position: absolute;
  right: 15px;
  top: 5px;
  width: 40px;
  height: 40px;

  padding: 0;

  color: ${({ theme }) => theme.text};

  background: none;
  border: 0;
  outline: 0;

  svg {
    height: 100%;
    width: 100%;
  }

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    top: 50%;
    transform: translate(30%, -50%);
    width: 30px;
  `)}

  ${ui_1.deviceLandscape.all((0, styled_components_1.css) `
    height: 25px;
    width: 25px;
    right: 4px;
    top: 3px;
  `)}
`;
